export const generatorTooltipText = (label, color) => {
    // make sure the label is a string
    return chooseTooltipColor(`${label}`, color);
};

export const generatorTooltipFlex = (label, value, color) => {
    // add a label and a value in the same line
    return chooseTooltipColor(
        `<div class="tooltip__warning"><div>${label}</div><div class="value">${value}</div></div>`,
        color,
    );
};

const chooseTooltipColor = (value, color) => {
    // add color to the marker
    return `<li class=${color}>${value}</li>`;
};
